<template lang="pug">
    van-overlay(:show="show" :z-index="99999")
            .loading-box
                .loading-icon
                    span(v-for="v in 5" :key="v")
    </template>
<script>
export default {
    name: "YcLoading",

    props: {
        show: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style lang="less" scoped>
.loading-box        {display: flex;align-items: center;justify-content: center;height: 100%;background: rgba(255, 255, 255, 0.8);}
.loading-icon{width: 1.6rem;height: .8rem;margin: 0 auto;display: flex;justify-content: space-between;}
.loading-icon span{display: inline-block;width: .16rem;height: 100%;border-radius: .2rem;background: #fc7575;-webkit-animation: load 1s ease infinite;}
@-webkit-keyframes load{
    0%,100%{
        height: .8rem;
        background: #e02020;
    }
    50%{
        height: 1.6rem;
        margin: -.4rem 0;
        background: #fc7575;
    }
}
.loading-icon span:nth-child(2){-webkit-animation-delay:0.2s;}
.loading-icon span:nth-child(3){-webkit-animation-delay:0.4s;}
.loading-icon span:nth-child(4){-webkit-animation-delay:0.6s;}
.loading-icon span:nth-child(5){-webkit-animation-delay:0.8s;}
</style>